// @flow

export function parseBool(value: any) {
  switch (typeof value) {
    case 'boolean': return value;
    case 'string': return value.toLowerCase() === 'true';
    case 'number': return value !== 0;
    case 'object': return true;
    default: return false;
  }
}
